import React from 'react';
import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { Grid, makeStyles } from '@material-ui/core';

const RequestDetailEmptyPresenter = () => {
  const classes = useStyles();
  return (
    <Grid
      className={classes.root}
      container
      justifyContent="center"
      alignItems="center"
    >
      <CustomizedTypography
        className={classes.text}
        variant="h4"
        color="textSecondary"
        fontWeight="normal"
        align="center"
      >
        내 프로젝트의 받은 견적들을
        <br />
        비교해보세요.
      </CustomizedTypography>
    </Grid>
  );
};

export default RequestDetailEmptyPresenter;

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    backgroundColor: colorSet.gray200,
    zIndex: 1100
  },
  text: {
    color: '#CED4DA'
  }
}));
